import configManager from "../singleton/ConfigManager";
import configManagerEmitter from "../utils/configManagerEmitter";

AFRAME.registerComponent("avatar-inspect-collider", {
  init() {
    this.updateCollider = this.updateCollider.bind(this);
    this.onConfigUpdated = this.handleConfigUpdate.bind(this);
  },

  play() {
    configManagerEmitter.on("configUpdated", this.onConfigUpdated);
    if (configManager.synced) {
      this.updateCollider();
    }
  },

  pause() {
    configManagerEmitter.off("configUpdated", this.onConfigUpdated);
  },

  handleConfigUpdate() {
    this.updateCollider();
  },

  updateCollider() {
    const existingCollider = this.el.getObject3D("avatar-inspect-collider");

    if (!configManager.config.invisibleAvatar.enabled) {
      if (!existingCollider) {
        this.el.setObject3D(
          "avatar-inspect-collider",
          new THREE.Mesh(
            new THREE.BoxGeometry(0.3, 0.8, 0.3),
            new THREE.MeshBasicMaterial({
              visible: false
            })
          )
        );
      }
    } else if (existingCollider) {
      this.el.removeObject3D("avatar-inspect-collider");
    }
  },

  remove() {
    configManagerEmitter.off("configUpdated", this.handleConfigUpdate);
  }
});
